/* Pirkėjų virtuvės: the customer-story strip's desk arrows and the
   full-screen viewer, split out of sections/main-product.liquid, which
   sits at Shopify's 256 KB ceiling. Loaded deferred from the snippet,
   after fancybox.js, whose Carousel the viewer rides. */
(function () {
  'use strict';
  /* The snippet that links this file is rendered once per strip, and a
     product page has two (the side strip and the stories row), so the file
     arrived twice and every strip got two carousels and two autoplays — the
     row stepped twice in a row (user, 2026-10-14). Run once. */
  if (window.__nagiUgcBooted) return;
  window.__nagiUgcBooted = true;

  /* A clip's file is attached the first time it is asked to play, never
     before (snippets/ugc-video.liquid: the markup carries three renditions
     and no src). A strip card gets the 480p file; the viewer the 720p one
     on a phone and the full one on a desk. A derived URL that does not
     exist falls back to the full file. */
  function ugcSrc(v) {
    if (!v || v.getAttribute('src') || !v.dataset || !v.dataset.ugcSrc) return;
    var card = v.classList.contains('nagi-ugc__media');
    var narrow = window.matchMedia('(max-width: 899px)').matches;
    var full = v.dataset.ugcSrcFull || v.dataset.ugcSrc;
    var pick = card ? v.dataset.ugcSrc : (narrow ? (v.dataset.ugcSrcMid || full) : full);
    v.addEventListener('error', function onErr() {
      v.removeEventListener('error', onErr);
      if (v.getAttribute('src') !== full) { v.src = full; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    });
    v.src = pick;
  }
  function ugcPlay(v) { ugcSrc(v); var p = v.play(); if (p && p.catch) p.catch(function () {}); }

  /* The strip's clips run while their card is on screen, as the autoplay
     attribute used to have them do, without the attribute's price: the
     file arrives when the card does, and only the small one. Clones the
     carousel makes later are picked up on the next look. */
  var cardIo = null;
  function watchCards() {
    if (!('IntersectionObserver' in window)) return;
    if (!cardIo) {
      cardIo = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          var v = e.target;
          v.__ugcSeen = e.isIntersecting && e.intersectionRatio >= 0.4;
          if (v.__ugcSeen) { if (!document.querySelector('.nagi-ugc-modal[open]')) ugcPlay(v); }
          else if (!v.paused) v.pause();
        });
      }, { threshold: [0, 0.4] });
    }
    Array.prototype.forEach.call(document.querySelectorAll('.nagi-ugc__card video[data-ugc-src]'), function (v) {
      if (v.__ugcIo) return;
      v.__ugcIo = true;
      cardIo.observe(v);
    });
  }
  watchCards();
  window.addEventListener('load', function () { setTimeout(watchCards, 600); });
  document.addEventListener('nagi:ugc-built', watchCards);

  /* Pirkėjų virtuvės. The strip's cards and its button all open the one
     viewer; the card tapped is the slide it opens on. nagi-modal.js owns the
     dialog (it opens on the same click, from its own delegated listener), so
     the work here is the track and its clock: which slide is in view, the
     bar that fills while it is, the move to the next when its time is up
     (a photo runs the section's seconds, a video its own length), the
     wrap from the last back to the first, and the hold while a finger is
     down — the stories everyone already knows how to watch. */
  /* Every viewer on the page, not only the first: a product page carries
     the strip's and the stories row's (user, 2026-10-14 — the row's opened
     with its photos stacked). */
  Array.prototype.forEach.call(document.querySelectorAll('[data-ugc-viewer]'), function (viewer) {
    var track = viewer.querySelector('[data-ugc-track]');
    var bars = Array.prototype.slice.call(viewer.querySelectorAll('.nagi-ugc-modal__bars span'));
    var n = track ? track.querySelectorAll('[data-ugc-slide]').length : 0;
    if (!track || !n) return;
    var PHOTO_MS = (parseFloat(viewer.getAttribute('data-ugc-seconds')) || 5) * 1000;
    var car = null;
    var current = -1;
    var clock = { raf: 0, from: 0, banked: 0, held: false };

    function isOpen() { return viewer.hasAttribute('open'); }
    function play(v) { ugcSrc(v); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    function allVideos() { return Array.prototype.slice.call(viewer.querySelectorAll('video')); }

    /* The carousel's own idea of where it stands and of which element
       shows for a page — asked of it each time, so a slide it has moved
       or rebuilt is still the one that gets played. */
    function at() {
      if (!car || typeof car.getPage !== 'function') return 0;
      var pg = car.getPage();
      return pg && typeof pg.index === 'number' ? pg.index : 0;
    }
    function slideEl(i) {
      if (car && typeof car.getPages === 'function') {
        var pg = car.getPages()[i];
        var sl = pg && pg.slides && pg.slides[0];
        if (sl && sl.el) return sl.el;
      }
      return track.querySelectorAll('[data-ugc-slide]')[i] || null;
    }
    function videoOf(i) { var el = slideEl(i); return el ? el.querySelector('video') : null; }

    function setBars(i, p) {
      bars.forEach(function (b, k) {
        b.classList.toggle('is-done', k < i);
        b.classList.toggle('is-on', k === i);
        if (k === i) b.style.setProperty('--p', String(Math.max(0, Math.min(1, p))));
      });
    }

    /* The clock of the slide in view. A photo's is time banked plus time
       since it last started; a video's is the video itself. */
    function restart() {
      clock.banked = 0;
      clock.from = performance.now();
      clock.held = false;
      var v = videoOf(current);
      if (v) {
        try { v.currentTime = 0; } catch (e) {}
        voice(v);
      }
    }

    /* Sound. The strip's clips run silent; here a video plays with sound
       (user, 2026-10-16: "su garsu tik kai atsidaro preview"), unless the
       person turned it off — kept for the rest of the visit. A browser that
       refuses sound without a fresh tap gets the clip silent and the button
       showing it off, one tap from on. */
    var soundBtn = viewer.querySelector('[data-ugc-sound]');
    var wantSound = true;
    function soundUi(v) {
      if (!soundBtn) return;
      soundBtn.hidden = !v;
      var on = !!v && !v.muted;
      soundBtn.classList.toggle('is-off', !on);
      soundBtn.setAttribute('aria-label', soundBtn.getAttribute(on ? 'data-on' : 'data-off') || '');
    }
    function voice(v) {
      ugcSrc(v);
      v.muted = !wantSound;
      var p = v.play();
      if (p && p.catch) {
        p.catch(function () {
          if (v.muted) return;
          v.muted = true;
          soundUi(v);
          play(v);
        });
      }
      soundUi(v);
    }
    function progress(now) {
      var v = videoOf(current);
      if (v) return v.duration ? v.currentTime / v.duration : 0;
      return (clock.banked + (clock.held ? 0 : now - clock.from)) / PHOTO_MS;
    }
    function frame(now) {
      clock.raf = 0;
      if (!isOpen() || current < 0) return;
      var p = progress(now);
      setBars(current, p);
      if (!clock.held && !videoOf(current) && p >= 1) { step(1); return; }
      clock.raf = window.requestAnimationFrame(frame);
    }
    function run() {
      if (!clock.raf) clock.raf = window.requestAnimationFrame(frame);
    }
    function hold(on) {
      if (clock.held === on) return;
      var now = performance.now();
      if (on) clock.banked += now - clock.from;
      else clock.from = now;
      clock.held = on;
      var v = videoOf(current);
      if (v) { if (on) v.pause(); else play(v); }
    }

    /* The words for the slide in view, written into the dialog's one top
       row and one foot from the slide's own attributes — the picture
       slides, the words swap and fade in (user, 2026-10-12). */
    /* Looked up inside the row and the foot: the slides carry the same
       attribute names as their data, and a search from the dialog's root
       lands on the first slide instead. */
    var topEl = viewer.querySelector('[data-ugc-top]');
    var footEl = viewer.querySelector('[data-ugc-foot]');
    var whoEl = topEl && topEl.querySelector('[data-ugc-who]');
    var whatEl = topEl && topEl.querySelector('[data-ugc-what]');
    var starsEl = footEl && footEl.querySelector('[data-ugc-stars]');
    var quoteEl = footEl && footEl.querySelector('[data-ugc-quote]');
    function caption(i) {
      var el = slideEl(i);
      if (!el || !topEl || !footEl || !whoEl || !starsEl) return;
      var d = el.dataset || {};
      var who = d.ugcWho || '', what = d.ugcWhat || '', quote = d.ugcQuote || '';
      var n = parseInt(d.ugcStars, 10) || 0;
      whoEl.textContent = who;
      whatEl.textContent = what ? '· ' + what : '';
      topEl.hidden = !(who || what);
      Array.prototype.forEach.call(starsEl.children, function (s, k) { s.hidden = k >= n; });
      starsEl.hidden = n === 0;
      starsEl.setAttribute('aria-label', n ? n + ' ' + ((window.nagiStrings && window.nagiStrings.ugc_stars_of_5) || 'iš 5') : '');
      quoteEl.textContent = quote ? '„' + quote + '“' : '';
      quoteEl.hidden = !quote;
      footEl.hidden = !(n || quote);
      [topEl, footEl].forEach(function (e) { e.classList.remove('is-in'); void e.offsetWidth; e.classList.add('is-in'); });
    }

    function paint(i) {
      if (i === current) return;
      var mine = videoOf(i);
      allVideos().forEach(function (v) { if (v !== mine) v.pause(); });
      current = i;
      caption(i);
      soundUi(mine);
      restart();
      setBars(i, 0);
      run();
    }

    /* The carousel is built on each opening, starting on the card that was
       tapped, and taken down on closing: a fresh instance is the one way to
       open instantly on any slide, and the dialog is display:none between
       openings, which is no place to keep one measured. Infinite, so the
       last slide drags on to the first; the carousel picks the short way. */
    function build(start) {
      if (car || !window.Carousel) return;
      car = window.Carousel(track, {
        slidesPerPage: 1,
        infinite: n > 1,
        center: false,
        fill: true,
        dragFree: false,
        transition: 'slide',
        initialPage: start,
        on: {
          change: function () { paint(at()); },
          ready: function () { paint(at()); }
        }
      }).init();
      /* initialPage is not honoured by this build; a transition-less goTo
         lands on the card instantly, before anything is painted. */
      if (at() !== start && typeof car.goTo === 'function') car.goTo(start, { transition: false });
      paint(at());
    }
    function tear() {
      if (!car) return;
      try { car.destroy(); } catch (e) {}
      car = null;
    }
    function step(d) {
      if (!car) return;
      if (d > 0) car.next(); else car.prev();
    }
    function open(i) {
      tear();
      current = -1;
      build(i);
      if (!car) paint(i);
    }

    allVideos().forEach(function (v) {
      v.addEventListener('ended', function () {
        if (isOpen() && v === videoOf(current)) step(1);
      });
    });

    /* The opener's own listener is nagi-modal.js's, on the document as well;
       whichever of the two runs first, the dialog is open and laid out by
       the next frame, which is when the carousel can be built inside it. */
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-ugc-go]') : null;
      if (!t) return;
      var target = t.getAttribute('data-nagi-modal-open');
      if (target && target !== viewer.id) return;
      var i = parseInt(t.getAttribute('data-ugc-go'), 10) || 0;
      window.requestAnimationFrame(function () { open(i); });
    });

    /* A finger or a mouse button down anywhere but the close button holds
       the clock; letting go, or a gesture the browser cancels, lets it run.
       Where it went down is kept, to tell a tap from a drag afterwards. */
    var px = 0, py = 0;
    viewer.addEventListener('pointerdown', function (e) {
      px = e.clientX; py = e.clientY;
      if (e.target && e.target.closest && e.target.closest('[data-nagi-modal-close], [data-ugc-sound]')) return;
      hold(true);
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) {
      viewer.addEventListener(ev, function () { hold(false); });
    });

    /* A tap on the picture steps: the left third back, the right third on,
       the middle nothing. A pointer that travelled is a drag the carousel
       has already answered. */
    viewer.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      if (e.target.closest('[data-ugc-sound]')) {
        var sv = videoOf(current);
        if (!sv) return;
        wantSound = sv.muted;
        sv.muted = !wantSound;
        play(sv);
        soundUi(sv);
        return;
      }
      if (e.target.closest('[data-ugc-prev]')) { step(-1); return; }
      if (e.target.closest('[data-ugc-next]')) { step(1); return; }
      if (!e.target.closest('[data-ugc-track]')) return;
      if (Math.abs(e.clientX - px) > 6 || Math.abs(e.clientY - py) > 6) return;
      var box = viewer.getBoundingClientRect();
      var x = (e.clientX - box.left) / (box.width || 1);
      if (x < 0.3) step(-1);
      else if (x > 0.7) step(1);
    });

    viewer.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      else if (e.key === ' ') { e.preventDefault(); hold(!clock.held); }
    });

    document.addEventListener('visibilitychange', function () {
      if (isOpen()) hold(document.hidden);
    });

    /* A story left running behind a closed dialog is a clock advancing
       slides nobody sees and a video still downloading. */
    viewer.addEventListener('close', function () {
      if (clock.raf) { window.cancelAnimationFrame(clock.raf); clock.raf = 0; }
      allVideos().forEach(function (v) { v.pause(); v.muted = true; });
      current = -1;
      tear();
      cards(true);
    });

    /* The strip's own clips stop while the viewer is open — one picture
       moving, one sound playing — and carry on when it closes. */
    function cards(go) {
      Array.prototype.forEach.call(document.querySelectorAll('.nagi-ugc__card video'), function (v) {
        if (go) { if (v.__ugcSeen) play(v); } else v.pause();
      });
    }
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest('[data-ugc-go]') : null;
      if (t && t.getAttribute('data-nagi-modal-open') === viewer.id) cards(false);
    });
  });

  /* A video card's hover preview: its bar runs the clip's length (set on
     the card by the snippet), so the clip starts over as the pointer
     arrives and the two run together. */
  document.addEventListener('mouseover', function (e) {
    var card = e.target && e.target.closest ? e.target.closest('.nagi-ugc__card') : null;
    if (!card || (e.relatedTarget && card.contains(e.relatedTarget))) return;
    var v = card.querySelector('video');
    if (!v) return;
    try { v.currentTime = 0; } catch (err) {}
    ugcPlay(v);
  });

  /* The strip: a Fancyapps Carousel — the library fancybox.js already
     brings to this page for the gallery — rather than a scroll row of our
     own (user, 2026-10-12: "naudojam carousel iš fancyapps? nes ten turėtų
     viskas būt padaryta ir gerai veikti"). One card a step, infinite, so
     the last card runs on into the first with no cut; a drag with the
     library's own physics; the two arrows in the heading; and its Autoplay
     plugin to move it on.

     The push: the first step 2.5 s after the strip comes into view, then
     one every 6 s (user: "svarbu buvo dažnumas"), each move a quick spring
     of about half a second (user: "0,4–0,5"); paused while a mouse rests on
     the strip, while it is off screen and while the tab is hidden; ended
     for good the first time the person drags it sideways, wheels it
     sideways or clicks anything in it ("kol žmogus pats nepaslidina ar
     nepaclickina"). A page scroll that happens to start on it does not end
     it. Reduced motion: no push at all.

     fancybox.js is deferred and comes later in the page than this file,
     so the carousel is built once the document has loaded its scripts. */
  Array.prototype.forEach.call(document.querySelectorAll('.nagi-ugc'), function (root) {
    var strip = root.querySelector('[data-ugc-strip]');
    if (!strip) return;
    var prev = root.querySelector('[data-ugc-strip-prev]');
    var next = root.querySelector('[data-ugc-strip-next]');
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    /* A strip may ask for its own step (the home row moves faster than the
       product page's, user 2026-10-13); 3 s otherwise (both, the same day). */
    var stepAttr = parseFloat(strip.getAttribute('data-ugc-step'));
    var STEP_MS = stepAttr > 0 ? stepAttr * 1000 : 3000, FIRST_MS = 1500;
    var car = null, auto = null, moved = false, started = false, dead = false, seen = false;

    function wake() {
      if (!auto || dead || document.hidden || !seen) return;
      if (!started) { started = true; auto.start(); } else auto.resume();
    }
    function sleep() { if (auto && started && !dead) auto.pause(); }
    function kill() { if (dead) return; dead = true; if (auto) auto.stop(); }
    /* A hand on the strip no longer ends the push for good (user,
       2026-10-13: after a swipe it stood still). The timer is held while
       the hand moves the row and starts again from zero once it lets go,
       so the next step comes a full interval after the person's own, never
       a moment after it. */
    var holdT = 0, holding = false;
    function hold() {
      if (!auto || dead) return;
      holding = true;
      if (holdT) { clearTimeout(holdT); holdT = 0; }
      if (started) auto.stop();
    }
    function release() {
      if (!holding || !auto || dead) return;
      if (holdT) clearTimeout(holdT);
      holdT = setTimeout(function () {
        holdT = 0; holding = false; moved = true;
        /* Off screen: let wake() start it afresh when it comes back. */
        if (document.hidden || !seen) { started = false; return; }
        started = true; auto.start();
      }, 300);
    }

    /* Both arrows stand while there is anywhere to go; a strip whose cards
       all fit shows neither. When the carousel is not infinite (too few
       cards to loop) the arrow at an end dims. */
    function sync() {
      if (!car || !prev || !next) return;
      var pages = car.getPages().length;
      var many = pages > 1;
      prev.hidden = next.hidden = !many;
      if (!many) return;
      var loop = car.isInfinite();
      var at = car.getPageIndex();
      prev.disabled = !loop && at <= 0;
      next.disabled = !loop && at >= pages - 1;
    }

    function build() {
      if (car || !window.Carousel) return;
      var plugins = {};
      if (window.Autoplay && !still) plugins.Autoplay = window.Autoplay;
      car = window.Carousel(strip, {
        slidesPerPage: 1,
        infinite: true,
        /* The stories row on a phone or a narrow window: the current card in
           the middle, its neighbours peeking at both edges (user,
           2026-10-14: two cards left-set with gaps either side looked off). */
        center: !!strip.closest('.nagi-ugcrow') && window.matchMedia('(max-width: 899px)').matches,
        fill: true,
        dragFree: false,
        transition: 'tween',
        /* A touch stiffer than the library's 160/25: the step lands in about
           half a second, still eased, still without overshoot. */
        /* Stiffer again (2026-10-13): the step lands in about 0.4 s. */
        tween: { clamp: true, mass: 1, tension: 320, friction: 36, restDelta: 1, restSpeed: 1, velocity: 0 },
        Autoplay: {
          autoStart: false,
          /* Hover is handled below with hold()/release(): the plugin's own
             pause did not hold while the pointer rested on the row, so a
             card's hover preview was pulled away mid-play. */
          pauseOnHover: false,
          showProgressbar: false,
          /* The plugin counts from the end of the slide (~0.5 s), so the
             wait is the step less that: a new card every STEP_MS, start to start. */
          timeout: function () { return moved ? STEP_MS - 500 : FIRST_MS; }
        },
        on: {
          ready: sync,
          refresh: sync,
          change: function () { moved = true; sync(); }
        }
      }, plugins).init();
      auto = (car.getPlugins && car.getPlugins().Autoplay) || null;
      sync();
      document.dispatchEvent(new CustomEvent('nagi:ugc-built'));
      if (prev) prev.addEventListener('click', function () { if (car) car.prev(); });
      if (next) next.addEventListener('click', function () { if (car) car.next(); });
      wake();
    }

    /* What counts as the person taking over. A finger is read from touch
       events (a native page scroll cancels its pointer events), a mouse
       from pointer events; either ends the push only once it has moved
       sideways more than it has moved up or down. */
    var sx = 0, sy = 0, down = false;
    function pt(e) { var t = e.touches && e.touches[0]; return t ? [t.clientX, t.clientY] : [e.clientX, e.clientY]; }
    function began(e) { var p = pt(e); sx = p[0]; sy = p[1]; down = true; }
    function moved_(e) {
      if (!down) return;
      var p = pt(e), dx = Math.abs(p[0] - sx), dy = Math.abs(p[1] - sy);
      if (dx > 8 && dx > dy) hold();
    }
    function ended() { down = false; release(); }
    var opts = { passive: true, capture: true };
    root.addEventListener('touchstart', began, opts);
    root.addEventListener('touchmove', moved_, opts);
    root.addEventListener('touchend', ended, opts);
    root.addEventListener('touchcancel', ended, opts);
    root.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'touch') began(e); }, opts);
    root.addEventListener('pointermove', function (e) { if (e.pointerType !== 'touch') moved_(e); }, opts);
    root.addEventListener('pointerup', function (e) { if (e.pointerType !== 'touch') ended(); }, opts);
    root.addEventListener('pointercancel', function (e) { if (e.pointerType !== 'touch') ended(); }, opts);
    var wheelT = 0;
    root.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      hold();
      if (wheelT) clearTimeout(wheelT);
      wheelT = setTimeout(release, 200);
    }, opts);
    /* An arrow or a card pressed counts the same: the row restarts its
       count from the press. */
    root.addEventListener('click', function () { hold(); release(); }, true);
    /* A mouse resting on the row holds it still (the card under it is
       playing its preview); leaving starts a full interval again. */
    if (window.matchMedia('(hover: hover)').matches) {
      strip.addEventListener('mouseenter', hold);
      strip.addEventListener('mouseleave', release);
    }

    document.addEventListener('visibilitychange', function () { if (document.hidden) sleep(); else wake(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          seen = e.isIntersecting && e.intersectionRatio >= 0.35;
          if (seen) wake(); else sleep();
        });
      }, { threshold: [0, 0.35] }).observe(strip);
    } else {
      seen = true;
    }

    function boot() {
      if (window.Carousel) { build(); return; }
      window.addEventListener('load', function () { build(); }, { once: true });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
    else boot();
  });
})();
